import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : false,
    country: [],
    totalCountry: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    iscloading:false,
    cstatus:"",
    cmessage:"",
    cdetails:{},
    ismloading:false,
    mstatus:"",
    mmessage:"",
    countries: {},
    dstatus:"",
    dmessage:"",
    
};


const countryListSlice = createSlice({
    name: "countryList",
    initialState,
    reducers:{
        getCountryPending: (state) => {
            state.isLoading = true;
        },
        getCountrySuccess: (state, { payload }) => {
            state.isLoading = false;
            state.country = payload;
            state.cdetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getCountryFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        createCountryPending:(state,action) => {
            state.iscloading=true;
        },
        createCountrySuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createCountryFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },
        getSCountryPending: (state) => {
            state.isLoading = true;
        },
        getSCountrySuccess: (state, { payload }) => {
            state.isLoading = false;
            state.countries=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSCountryFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        modifyCountryPending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyCountrySuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.mmessage="Country Successfully Updated";
        },
        modifyCountryFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
           // console.log('slice '+payload);
            state.mmessage=payload;
        },
        deleteCountryPending:(state,action) => {
            state.isLoading=true;
            state.dstatus="";
        },
        deleteCountrySuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="Country Successfully Deleted";
           
        },
        deleteCountryFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = countryListSlice;

export const { getCountryPending, getCountrySuccess, getCountryFail,getSCountryPending, getSCountrySuccess, getSCountryFail, 
    createCountryPending, createCountrySuccess, createCountryFail,
    modifyCountryPending,modifyCountrySuccess,modifyCountryFail,
    deleteCountryPending,deleteCountrySuccess,deleteCountryFail  } = actions;

export default reducer;
